export default __webpack_public_path__ + "static/image-highlight-vps-api-0af5d3b49bb0b1b53f875304460dc279.png";